module.exports = __webpack_public_path__ + "static/media/bankPermit.00c24d02.jpg";